import Component from "@glimmer/component";
import { concat } from "@ember/helper";
import { LinkTo } from "@ember/routing";
import { service } from "@ember/service";
import { trustHTML } from "@ember/template";
import FeaturedTopic from "discourse/components/featured-topic";
import PluginOutlet from "discourse/components/plugin-outlet";
import concatClass from "discourse/helpers/concat-class";
import lazyHash from "discourse/helpers/lazy-hash";
import CirclesBackground from "../background";
import CirclesLogo from "../logo";
import CirclesCardActions from "./actions";
import CirclesCardBadges from "./badges";
import CirclesCardStats from "./stats";

export default class CircleCard extends Component {
  @service siteSettings;

  get shouldDisplayDescription() {
    return (
      this.args.model.definition_raw !== "" &&
      !!this.args.model.category.description
    );
  }

  get description() {
    return this.args.model.category.description_excerpt;
  }

  get shouldDisplayFeaturedTopics() {
    return (
      this.siteSettings
        .discourse_circles_num_featured_topics_displayed_on_cards > 0
    );
  }

  get featuredTopics() {
    return this.args.model.category.topics;
  }

  <template>
    <div
      class={{concatClass
        "circles-card"
        (concat "circles-card-" @model.category_id)
        (if @model.is_circle_owner "circles-owned")
        (if
          this.shouldDisplayFeaturedTopics "circles-card--with-featured-topics"
        )
      }}
      data-category-id={{@model.category_id}}
    >
      <PluginOutlet @name="circles-card" @outletArgs={{lazyHash model=@model}}>
        <CirclesBackground class="circles-card__background" @model={{@model}} />
        <CirclesLogo class="circles-card__logo" @model={{@model}} />

        <LinkTo
          class="circles-card__name"
          @route="circle"
          @model={{@model.slug_path_with_id}}
        >
          {{@model.name}}
        </LinkTo>

        {{#if this.shouldDisplayDescription}}
          <div class="circles-card__description">
            <p>{{trustHTML this.description}}</p>
          </div>
        {{/if}}

        {{#if this.shouldDisplayFeaturedTopics}}
          <div class="circles-card__featured-topics-list">
            {{#each this.featuredTopics as |topic|}}
              <PluginOutlet
                @name="circles-card-featured-topic"
                @outletArgs={{lazyHash topic=topic}}
              >
                <FeaturedTopic
                  class="circles-card__featured-topic"
                  @topic={{topic}}
                />
              </PluginOutlet>
            {{/each}}
          </div>
        {{/if}}

        <CirclesCardStats @model={{@model}} />

        <CirclesCardBadges @model={{@model}} />

        <CirclesCardActions @model={{@model}} @showMembershipButton={{true}} />
      </PluginOutlet>
    </div>
  </template>
}
